
export default {
  toUnique (arr, field) {
    var unique = {}
    arr.forEach((item) => {
      unique[item[field]] = item
    })
    return Object.values(unique)
  },
  isUndefined (obj) {
    return typeof obj === 'undefined'
  },
  inArray (obj, arr, field) {
    let find = false
    arr.forEach((item) => {
      if (field) {
        if (obj === item[field]) {
          find = true
        }
      } else {
        if (obj === item) {
          find = true
        }
      }
    })
    return find
  },
  divideArray (arr, len) {
    let chunks = []
    let i = 0
    let n = arr.length

    while (i < n) {
      chunks.push(arr.slice(i, i += len))
    }
    return chunks
  },
  maskToArray (mask) {
    let selectedAuth = []
    Array.from(mask).forEach((auth, i) => {
      if (auth === '1') {
        selectedAuth.push(i)
      }
    })
    return selectedAuth
  },
  arrayToMask (authArray) {
    let selectedAuth = [].fill.call(new Array(32), '0')
    authArray.forEach((auth) => {
      selectedAuth[parseInt(auth)] = '1'
    })
    return selectedAuth.join('')
  },
  copyObject (src) {
    return JSON.parse(JSON.stringify(src))
  },
  urlEncode (params) {
    return '?' + Object.keys(params).filter((key) => {
      return params[key]
    }).map((key) => {
      return key + '=' + params[key]
    }).join('&')
  },
  findInArray (arr, value, retField, findField) {
    findField = findField || 'value'
    let found = arr.find((obj) => {
      return obj[findField] === value
    })
    return found ? found[retField] : null
  },
  parseQs (params) {
    var str = []
    for (var k in params) {
      str.push(k + '=' + (typeof params[k] === 'object' ? JSON.stringify(params[k]) : params[k]))
    }
    return str.join('&')
  },
  checkAdminType (needType, loginInfo) {
    let adminSeq = ['editor', 'normal', 'qa', 'super']
    if (!this.isUndefined(needType) && (this.isUndefined(loginInfo) || adminSeq.indexOf(loginInfo.admin_type) < adminSeq.indexOf(needType))) {
      return false
    }
    return true
  },
  formatDate (dt) {
    return dt.toISOString().slice(0, 19).replace(/T/, ' ')
  },
  getAuthOptions (authMask) {
    let options = []
    let texts = [
      '人员管理', '读数据', '写数据', '读配置', '写配置', '查看文档',
      '写数据（高级）', '写配置（高级）', '读数据（高级）', '读配置（高级）'
    ]
    texts.forEach((text, i) => {
      options.push({'value': i + 1, 'text': text})
    })
    return options
  },
  checkVoteAuth (loginInfo) {
    return loginInfo.vote
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js